export default "/images/sun.svg?ed23b430cb9f4147d84c4c1379c6cc97";